import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  elevation1: {
    boxShadow: '0px 3px 6px rgba(0, 0, 0, .29)',
  },
  rounded: {
    borderRadius: 0,
  },
  menuItem: {
    minHeight: 0,
    padding: 0,
    flexDirection: 'column',
    alignItems: 'flex-start',
    fontSize: 15,
    fontFamily: 'NeoSansStd',
    fontWeight: 400,
    color: theme.custom.darkBlue,
    textDecoration: 'none',
    whiteSpace: 'unset',
  },
  menuLabel: {
    display: 'block',
    width: '100%',
    padding: '6px 10px',
  },
  menuList: {
    maxHeight: '100%',
  },
}));
